import React from "react";
import check from "./../../../Images/checked.png";

const SheaButterHairSpaWhyChoose = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Why Choose Shea Butter for Your Hair?</h5>
      <p>
        Shea butter is nature’s miracle ingredient, rich in vitamins A and E,
        fatty acids, and essential nutrients that deeply moisturize and repair
        damaged hair. At <a href="https://scentlifestyle.com/">SCENT</a>, we
        harness the power of shea butter to create a transformative experience
        with our Shea Butter Hair Spa in Bangalore. Here’s why this treatment is
        ideal for your hair:
      </p>
      <ul>
        <li>
          <span>
            <img src={check} alt="check" />
            Intense Hydration:{" "}
          </span>
          <p>
            Shea butter deeply penetrates the hair shaft, locking in moisture
            and preventing dryness.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={check} alt="check" />
            Repair and Strengthen:{" "}
          </span>
          <p>
            Its rich nutrients repair damage caused by heat, chemicals, and
            environmental factors.
          </p>
        </li>
        <li>
          <span>
            <img src={check} alt="check" />
            Frizz Control:{" "}
          </span>
          <p>
            Smoothens and tames unruly hair, leaving it silky and manageable.
          </p>
        </li>
        <li>
          <span>
            <img src={check} alt="check" />
            Scalp Health:{" "}
          </span>
          <p>
            Soothes and nourishes the scalp, addressing issues like dryness and
            flakiness.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default SheaButterHairSpaWhyChoose;
